import React from 'react';
import createReactClass from 'create-react-class';
import ReviewMixin from '../mixins/mixin';
import './index.scss';

var BookingReviewDefault = createReactClass({
  displayName: 'BookingReview-Default-AnyGuide',

  mixins: [ReviewMixin],

  getDefaultProps: function () {
    return {
      theme: 't-Default',
    };
  },

  render: function () {
    return (
      <div className="BookingReview-Container t-Default">
        {this._renderStep()[this.state.step]}
      </div>
    );
  },
});

export default BookingReviewDefault;
